/* @generated from adl module common.http */

import * as ADL from './../runtime/adl';
import * as sys_types from './../sys/types';

/**
 * A marker type to associate the output response
 * type for an http Get request.
 */
export type Get<_I> = null;

const Get_AST : ADL.ScopedDecl =
  {"moduleName":"common.http","decl":{"annotations":[],"type_":{"kind":"type_","value":{"typeParams":["I"],"typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}}},"name":"Get","version":{"kind":"nothing"}}};

export const snGet: ADL.ScopedName = {moduleName:"common.http", name:"Get"};

export function texprGet<I>(texprI : ADL.ATypeExpr<I>): ADL.ATypeExpr<Get<I>> {
  return {value : {typeRef : {kind: "reference", value : {moduleName : "common.http",name : "Get"}}, parameters : [texprI.value]}};
}

/**
 * A marker type to associate the input request and output response
 * types for an http put request.
 */
export type Put<_I, _O> = null;

const Put_AST : ADL.ScopedDecl =
  {"moduleName":"common.http","decl":{"annotations":[],"type_":{"kind":"type_","value":{"typeParams":["I","O"],"typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}}},"name":"Put","version":{"kind":"nothing"}}};

export const snPut: ADL.ScopedName = {moduleName:"common.http", name:"Put"};

export function texprPut<I, O>(texprI : ADL.ATypeExpr<I>, texprO : ADL.ATypeExpr<O>): ADL.ATypeExpr<Put<I, O>> {
  return {value : {typeRef : {kind: "reference", value : {moduleName : "common.http",name : "Put"}}, parameters : [texprI.value, texprO.value]}};
}

/**
 * A marker type to associate the input request and output response
 * types for an http post request.
 */
export type Post<_I, _O> = null;

const Post_AST : ADL.ScopedDecl =
  {"moduleName":"common.http","decl":{"annotations":[],"type_":{"kind":"type_","value":{"typeParams":["I","O"],"typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}}},"name":"Post","version":{"kind":"nothing"}}};

export const snPost: ADL.ScopedName = {moduleName:"common.http", name:"Post"};

export function texprPost<I, O>(texprI : ADL.ATypeExpr<I>, texprO : ADL.ATypeExpr<O>): ADL.ATypeExpr<Post<I, O>> {
  return {value : {typeRef : {kind: "reference", value : {moduleName : "common.http",name : "Post"}}, parameters : [texprI.value, texprO.value]}};
}

/**
 * An annotation indicating the URL path for a request
 */
export type Path = string;

const Path_AST : ADL.ScopedDecl =
  {"moduleName":"common.http","decl":{"annotations":[],"type_":{"kind":"type_","value":{"typeParams":[],"typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}}},"name":"Path","version":{"kind":"nothing"}}};

export const snPath: ADL.ScopedName = {moduleName:"common.http", name:"Path"};

export function texprPath(): ADL.ATypeExpr<Path> {
  return {value : {typeRef : {kind: "reference", value : snPath}, parameters : []}};
}

/**
 * An annotation indicating that a request requires an Authorization http header
 */
export type AuthHeader = null;

const AuthHeader_AST : ADL.ScopedDecl =
  {"moduleName":"common.http","decl":{"annotations":[],"type_":{"kind":"type_","value":{"typeParams":[],"typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}}},"name":"AuthHeader","version":{"kind":"nothing"}}};

export const snAuthHeader: ADL.ScopedName = {moduleName:"common.http", name:"AuthHeader"};

export function texprAuthHeader(): ADL.ATypeExpr<AuthHeader> {
  return {value : {typeRef : {kind: "reference", value : snAuthHeader}, parameters : []}};
}

/**
 * An annotation indicating that a request is idemponent, and can hence be safely
 * retried on failure.
 */
export type Idempotent = null;

const Idempotent_AST : ADL.ScopedDecl =
  {"moduleName":"common.http","decl":{"annotations":[],"type_":{"kind":"type_","value":{"typeParams":[],"typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}}},"name":"Idempotent","version":{"kind":"nothing"}}};

export const snIdempotent: ADL.ScopedName = {moduleName:"common.http", name:"Idempotent"};

export function texprIdempotent(): ADL.ATypeExpr<Idempotent> {
  return {value : {typeRef : {kind: "reference", value : snIdempotent}, parameters : []}};
}

/**
 * An annotation indicating that a request can be made idempotent if the caller
 * provides an Idempotency-Key header with a unique value.
 */
export type IdempotentWithKey = null;

const IdempotentWithKey_AST : ADL.ScopedDecl =
  {"moduleName":"common.http","decl":{"annotations":[],"type_":{"kind":"type_","value":{"typeParams":[],"typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}}},"name":"IdempotentWithKey","version":{"kind":"nothing"}}};

export const snIdempotentWithKey: ADL.ScopedName = {moduleName:"common.http", name:"IdempotentWithKey"};

export function texprIdempotentWithKey(): ADL.ATypeExpr<IdempotentWithKey> {
  return {value : {typeRef : {kind: "reference", value : snIdempotentWithKey}, parameters : []}};
}

/**
 * The standard message body for errors
 */
export interface PublicErrorData {
  publicMessage: string;
}

export function makePublicErrorData(
  input: {
    publicMessage: string,
  }
): PublicErrorData {
  return {
    publicMessage: input.publicMessage,
  };
}

const PublicErrorData_AST : ADL.ScopedDecl =
  {"moduleName":"common.http","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"publicMessage","default":{"kind":"nothing"},"name":"publicMessage","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}}]}},"name":"PublicErrorData","version":{"kind":"nothing"}}};

export const snPublicErrorData: ADL.ScopedName = {moduleName:"common.http", name:"PublicErrorData"};

export function texprPublicErrorData(): ADL.ATypeExpr<PublicErrorData> {
  return {value : {typeRef : {kind: "reference", value : snPublicErrorData}, parameters : []}};
}

/**
 * New request types
 */
export interface HttpGet<O> {
  path: string;
  roles: sys_types.Set<string>;
  respType: ADL.ATypeExpr<O>;
}

const HttpGet_AST : ADL.ScopedDecl =
  {"moduleName":"common.http","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":["O"],"fields":[{"annotations":[],"serializedName":"path","default":{"kind":"nothing"},"name":"path","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"roles","default":{"kind":"nothing"},"name":"roles","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"sys.types","name":"Set"}},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}},{"annotations":[],"serializedName":"respType","default":{"kind":"just","value":null},"name":"respType","typeExpr":{"typeRef":{"kind":"primitive","value":"TypeToken"},"parameters":[{"typeRef":{"kind":"typeParam","value":"O"},"parameters":[]}]}}]}},"name":"HttpGet","version":{"kind":"nothing"}}};

export const snHttpGet: ADL.ScopedName = {moduleName:"common.http", name:"HttpGet"};

export function texprHttpGet<O>(texprO : ADL.ATypeExpr<O>): ADL.ATypeExpr<HttpGet<O>> {
  return {value : {typeRef : {kind: "reference", value : {moduleName : "common.http",name : "HttpGet"}}, parameters : [texprO.value]}};
}

export interface HttpPut<I, O> {
  path: string;
  roles: sys_types.Set<string>;
  reqType: ADL.ATypeExpr<I>;
  respType: ADL.ATypeExpr<O>;
}

const HttpPut_AST : ADL.ScopedDecl =
  {"moduleName":"common.http","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":["I","O"],"fields":[{"annotations":[],"serializedName":"path","default":{"kind":"nothing"},"name":"path","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"roles","default":{"kind":"nothing"},"name":"roles","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"sys.types","name":"Set"}},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}},{"annotations":[],"serializedName":"reqType","default":{"kind":"just","value":null},"name":"reqType","typeExpr":{"typeRef":{"kind":"primitive","value":"TypeToken"},"parameters":[{"typeRef":{"kind":"typeParam","value":"I"},"parameters":[]}]}},{"annotations":[],"serializedName":"respType","default":{"kind":"just","value":null},"name":"respType","typeExpr":{"typeRef":{"kind":"primitive","value":"TypeToken"},"parameters":[{"typeRef":{"kind":"typeParam","value":"O"},"parameters":[]}]}}]}},"name":"HttpPut","version":{"kind":"nothing"}}};

export const snHttpPut: ADL.ScopedName = {moduleName:"common.http", name:"HttpPut"};

export function texprHttpPut<I, O>(texprI : ADL.ATypeExpr<I>, texprO : ADL.ATypeExpr<O>): ADL.ATypeExpr<HttpPut<I, O>> {
  return {value : {typeRef : {kind: "reference", value : {moduleName : "common.http",name : "HttpPut"}}, parameters : [texprI.value, texprO.value]}};
}

export interface HttpPost<I, O> {
  path: string;
  roles: sys_types.Set<string>;
  reqType: ADL.ATypeExpr<I>;
  respType: ADL.ATypeExpr<O>;
}

const HttpPost_AST : ADL.ScopedDecl =
  {"moduleName":"common.http","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":["I","O"],"fields":[{"annotations":[],"serializedName":"path","default":{"kind":"nothing"},"name":"path","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"roles","default":{"kind":"nothing"},"name":"roles","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"sys.types","name":"Set"}},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}},{"annotations":[],"serializedName":"reqType","default":{"kind":"just","value":null},"name":"reqType","typeExpr":{"typeRef":{"kind":"primitive","value":"TypeToken"},"parameters":[{"typeRef":{"kind":"typeParam","value":"I"},"parameters":[]}]}},{"annotations":[],"serializedName":"respType","default":{"kind":"just","value":null},"name":"respType","typeExpr":{"typeRef":{"kind":"primitive","value":"TypeToken"},"parameters":[{"typeRef":{"kind":"typeParam","value":"O"},"parameters":[]}]}}]}},"name":"HttpPost","version":{"kind":"nothing"}}};

export const snHttpPost: ADL.ScopedName = {moduleName:"common.http", name:"HttpPost"};

export function texprHttpPost<I, O>(texprI : ADL.ATypeExpr<I>, texprO : ADL.ATypeExpr<O>): ADL.ATypeExpr<HttpPost<I, O>> {
  return {value : {typeRef : {kind: "reference", value : {moduleName : "common.http",name : "HttpPost"}}, parameters : [texprI.value, texprO.value]}};
}

export const _AST_MAP: { [key: string]: ADL.ScopedDecl } = {
  "common.http.Get" : Get_AST,
  "common.http.Put" : Put_AST,
  "common.http.Post" : Post_AST,
  "common.http.Path" : Path_AST,
  "common.http.AuthHeader" : AuthHeader_AST,
  "common.http.Idempotent" : Idempotent_AST,
  "common.http.IdempotentWithKey" : IdempotentWithKey_AST,
  "common.http.PublicErrorData" : PublicErrorData_AST,
  "common.http.HttpGet" : HttpGet_AST,
  "common.http.HttpPut" : HttpPut_AST,
  "common.http.HttpPost" : HttpPost_AST
};



// WEBPACK FOOTER //
// ./src/adl-gen/common/http.ts